import { FC, Fragment } from 'react';

import { Body, Bold, Gutter } from '@rikstv/shared-components';

import { MetadataSection } from '../contentStack.types';
import { KNOWN_LABELS } from '../hooks/useContentStackEventHandlers';

import styles from './ExtendedMetadata.module.css';

export const ExtendedMetadata: FC<Pick<MetadataSection, 'extendedMetadata'>> = ({ extendedMetadata }) => {
  const { description, descriptiveMetadata, technicalMetadata } = extendedMetadata;
  return (
    <Gutter>
      <div className={styles.extendedMetadata}>
        <dl>
          <dt>
            <Bold>{description.label}</Bold>
          </dt>
          <dd>
            <Body>{description.values.join()}</Body>
          </dd>
        </dl>
        <dl>
          {descriptiveMetadata.map(m => (
            <Fragment key={'descriptiveMetadata' + m.label}>
              <dt>
                <Bold>{m.label}</Bold>
              </dt>
              <dd>
                <Body>{m.values.join(m.label.startsWith(KNOWN_LABELS.actors) ? '\n' : ', ')}</Body>
              </dd>
            </Fragment>
          ))}
        </dl>
        <dl>
          {technicalMetadata.map(m => (
            <Fragment key={'technicalMetadata' + m.label}>
              <dt>
                <Bold>{m.label}</Bold>
              </dt>
              <dd>
                <Body>{m.values.join(', ')}</Body>
              </dd>
            </Fragment>
          ))}
        </dl>
      </div>
    </Gutter>
  );
};
